import { useCallback, useEffect, useState } from 'react';
import { listPending, drop } from '../data/local/outbox';
import { listarConflitos, resolverConflito, camposEmConflito } from '../data/conflitos';
import { currentUserId } from '../data/auth';

/**
 * Conflitos de edição aguardando decisão.
 *
 * Separados da fila normal porque não são problema técnico: são duas pessoas
 * que mexeram na mesma coisa, e só alguém que conhece o caso pode dizer qual
 * versão vale.
 */
export const useConflitos = () => {
  const [conflitos, setConflitos] = useState([]);
  const [resolvendo, setResolvendo] = useState(false);

  const recarregar = useCallback(async () => {
    setConflitos(await listarConflitos(listPending, await currentUserId()));
  }, []);

  useEffect(() => { recarregar(); }, [recarregar]);

  const resolver = useCallback(async (registro, escolha) => {
    setResolvendo(true);
    try {
      await resolverConflito(registro, escolha);
      // Sai da fila só depois de gravado: se a gravação falhar, o conflito
      // continua ali para tentar de novo, em vez de sumir levando o lançamento.
      await drop(registro.seq);
      await recarregar();
      return true;
    } catch (err) {
      console.error('Falha ao resolver conflito:', err);
      return false;
    } finally {
      setResolvendo(false);
    }
  }, [recarregar]);

  return { conflitos, resolvendo, resolver, recarregar, camposEmConflito };
};
